module.exports = __webpack_public_path__ + "static/media/bed-alt.b26ed1c4.svg";